<script setup>
import {defineProps, defineEmits, computed} from "vue"
import dayjs from "dayjs";
import moment from "moment";

import locale from "ant-design-vue/es/date-picker/locale/ru_RU"
import 'moment/locale/ru';

moment.locale("ru")
import 'dayjs/locale/ru';

dayjs.locale('ru');

const props = defineProps({
  modelValue: String,
});

const emit = defineEmits(['update:modelValue', 'onChange']);

function changeValue(value) {
  if (value === null) {
    emit('update:modelValue', null)
  } else {
    emit('update:modelValue', value.format('MM'))
  }
  emit('onChange')
}

const selected_date = computed(() => {
  return props.modelValue ? dayjs(props.modelValue,'MM') : undefined
})
</script>

<template>
  <div>
    <a-date-picker
		    @change="changeValue"
        :value="selected_date"
		    :locale="locale"
		    picker="month"
        placeholder="Выберите месяц"
    />
  </div>
</template>